// Generated by Melange

import RadioGroupModuleCss from "./radioGroup.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Shared__Label from "./label.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Webapi__Dom__HtmlInputElement from "melange-webapi/Webapi/Dom/Webapi__Dom__HtmlInputElement.jsx";
import Clsx from "clsx";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = RadioGroupModuleCss;

const context = React.createContext(undefined);

const make = context.Provider;

function use(param) {
  return Stdlib__Option.get(React.useContext(context));
}

const Context = {
  context: context,
  make: make,
  use: use
};

function RadioGroup$Root(Props) {
  let children = Props.children;
  let className = Props.className;
  let defaultValue = Props.defaultValue;
  let name = Props.name;
  let value = Props.value;
  let onValueChange = Props.onValueChange;
  const id = React.useId();
  const contextValue = React.useMemo((function () {
    return {
      defaultValue: defaultValue,
      id: id,
      name: name,
      value: value
    };
  }), [
    defaultValue,
    id,
    name,
    value
  ]);
  let tmp = {
    children: children,
    "aria-labelledby": id,
    className: Clsx(className, css.root),
    role: "radiogroup",
    onChange: (function ($$event) {
      const match = Curry._1(Webapi__Dom__HtmlInputElement.ofElement, $$event.target);
      if (match === undefined) {
        return;
      }
      if (onValueChange === undefined) {
        return;
      }
      const item = Caml_option.valFromOption(match);
      Curry._1(onValueChange, item.checked ? item.value : "");
    })
  };
  if (defaultValue !== undefined) {
    tmp.defaultValue = Caml_option.valFromOption(defaultValue);
  }
  if (name !== undefined) {
    tmp.name = Caml_option.valFromOption(name);
  }
  if (value !== undefined) {
    tmp.value = Caml_option.valFromOption(value);
  }
  return JsxRuntime.jsx(make, {
    value: contextValue,
    children: JsxRuntime.jsx("div", tmp)
  });
}

const Root = {
  make: RadioGroup$Root
};

function RadioGroup$Label(Props) {
  let children = Props.children;
  let className = Props.className;
  const contextValue = Stdlib__Option.get(React.useContext(context));
  let tmp = {
    children: children,
    id: contextValue.id
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  return JsxRuntime.jsx(Shared__Label.make, tmp);
}

const Label = {
  make: RadioGroup$Label
};

function RadioGroup$Item(Props) {
  let className = Props.className;
  let label = Props.label;
  let value = Props.value;
  const contextValue = Stdlib__Option.get(React.useContext(context));
  const match = contextValue.defaultValue;
  const match$1 = contextValue.value;
  let tmp = {
    className: Clsx(className, css.input),
    type: "radio",
    onChange: (function (param) {
      
    })
  };
  const tmp$1 = match !== undefined && value !== undefined ? value === match : undefined;
  if (tmp$1 !== undefined) {
    tmp.defaultChecked = Caml_option.valFromOption(tmp$1);
  }
  const tmp$2 = match$1 !== undefined && value !== undefined ? value === match$1 : undefined;
  if (tmp$2 !== undefined) {
    tmp.checked = Caml_option.valFromOption(tmp$2);
  }
  if (contextValue.name !== undefined) {
    tmp.name = Caml_option.valFromOption(contextValue.name);
  }
  if (value !== undefined) {
    tmp.value = Caml_option.valFromOption(value);
  }
  return JsxRuntime.jsxs(RadioGroup$Label, {
    children: [
      JsxRuntime.jsx("input", tmp),
      label
    ],
    className: css.label
  });
}

const Item = {
  make: RadioGroup$Item
};

export {
  Context,
  Root,
  Label,
  Item,
}
/* css Not a pure module */
